import React from 'react'
import AlertInfo from './alert-info'

export default function SegmentAlert() {
  return <AlertInfo />
}
